import { PrimaryButton } from '@client/new/components/button';
import { useForm } from 'react-hook-form';
import { Link } from 'react-router';
import { AuthLayout } from '../../auth.layout';
import { trackEvent } from '@services/tracking';
import { LoginFormValues, useLoginPageSubmit } from './login.page.vm';

type TextAlertProps = {
  content: string;
};

const TextAlert = ({ content }: TextAlertProps) => {
  return (
    <p role="alert" className="mt-4 text-center text-red-600">
      {content}
    </p>
  );
};

export const CreatorLoginPage = () => {
  const { register, handleSubmit } = useForm<LoginFormValues>();
  const { submitState, submitLogin } = useLoginPageSubmit();

  const handleSignUpClick = () => {
    trackEvent({
      type: 'Sign Up',
      payload: {},
    });
  };

  return (
    <AuthLayout title={'Sign in to Playbook'}>
      <div className="flex flex-col items-center">
        <form className="mt-8 w-full" onSubmit={handleSubmit(submitLogin)}>
          <input
            aria-label="Email address"
            type="email"
            required
            className="input w-full text-center"
            placeholder="Type your email"
            {...register('email', { required: true })}
          />
          <div className="w-full mt-5">
            <PrimaryButton
              large
              type="submit"
              isLoading={submitState.type === 'fetching'}
            >
              Continue
            </PrimaryButton>
          </div>
          {submitState.type === 'fetch-error' && (
            <TextAlert content={submitState.value} />
          )}
        </form>
        <p className="mt-10">
          {"We'll send you a code to sign in - no password required!"}
        </p>
        <p className="mt-5">
          <span className="font-bold">{"Don't have an account?"}</span>{' '}
          <Link className="link" to={'/sign-up'} onClick={handleSignUpClick}>
            Sign up
          </Link>
        </p>
      </div>
    </AuthLayout>
  );
};
